import { AdditionalText, BodyText, LabelText } from '@ui-components/typography/Typography'
import { JSX, ReactNode } from 'react'

export const Label = ({
  id,
  label,
  description,
  className,
  children,
  isRequired = false,
  labelIdOverride = undefined,
  as = 'label',
  useBodyText = false,
  ariaHiddenDescription,
}: {
  id: string
  label: ReactNode
  description?: ReactNode
  className?: string
  children?: ReactNode
  isRequired?: boolean
  labelIdOverride?: string
  as?: 'label' | 'legend' | 'span'
  useBodyText?: boolean
  /**
   * Use this when the description should not be part of the accessible name of an input.
   * e.g., when this component is wrapped by <label /> element like it is in <Radio /> component.
   * Note: just remember to link the description to the input with aria-describedby
   */
  ariaHiddenDescription?: boolean
}): JSX.Element => {
  const formattedLabel = isRequired ? `* ${label}` : label
  const TextComponent = useBodyText ? BodyText : LabelText
  return (
    <div className={className}>
      <TextComponent tagName={as} id={labelIdOverride ?? `${id}-label`} htmlFor={id}>
        {formattedLabel}
      </TextComponent>

      {description && (
        <AdditionalText aria-hidden={ariaHiddenDescription} tagName="div" id={`${id}-description`}>
          {description}
        </AdditionalText>
      )}

      {children && <BodyText tagName="div">{children}</BodyText>}
    </div>
  )
}
